import styled from "styled-components";

import {
  ChipAutoCompleteImagePlaceholder,
  ChipAutoCompleteItem,
  Description,
  Icon,
  IconButtonButton,
  Link,
  Text,
} from "@evergis/ui";

export const DialogDescription = styled(Description)`
  opacity: 0.54;
  margin-top: 0.5rem;
`;

export const UsersLabel = styled(Description)`
  padding: 0 0 0 0.5rem;
  margin: 0 0 4px;
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.25rem;

  ${ChipAutoCompleteItem} {
    background-color: rgba(0, 170, 255, 0.12);

    ${IconButtonButton} {
      ${Icon} {
        color: ${({ theme }) => theme.palette.textPrimary};
      }
    }

    ${Text} {
      color: ${({ theme }) => theme.palette.textPrimary};
    }

    ${ChipAutoCompleteImagePlaceholder} {
      background-color: rgba(0, 170, 255, 0.28);
      color: ${({ theme }) => theme.palette.textPrimary};
    }
  }
`;

export const AdditionalInfoLink = styled(Link).attrs(() => ({ target: "_blank" }))`
  padding-top: 0.5rem;
  font-size: 0.75rem;
  color: ${({ theme: { palette } }) => palette.textDisabled};

  ${Icon} {
    opacity: 0.54;
    margin-right: 0.5rem;
  }
`;
